import * as React from 'react';
import NativeAdPreloadingStubElement from './components/nativeAdPreloadingStubElement';
import { ComponentClass } from 'react';
import { createLazyComponent, LazyModule } from 'owa-bundling';
export { ComponentClass };

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "NativeAdList" */ './lazyIndex')
);

// Delay loaded components
export const NativeAdContainer = createLazyComponent(
    lazyModule,
    m => m.NativeAdList,
    () => <NativeAdPreloadingStubElement />,
    () => {} // Just ignore import errors
);
